export default __webpack_public_path__ + "static/media/product-details-2.ddd6c858.jpg";